import { useState } from "react";
import { LanguageDropdown } from "../../components/LanguageDropdown";
import { useHeader } from "../../contexts/HeaderContext";
import { useTranslation } from "react-i18next";
import { FiClock, FiAlertCircle } from "react-icons/fi";

const Expired = () => {
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const { t } = useTranslation();
  const { selectedLanguage, setSelectedLanguage } = useHeader();

  return (
    <div
      data-testid="expired-page"
      className="min-h-screen bg-gradient-to-br from-surface-page to-surface-hover"
    >
      <div className="pl-8 pt-4">
        <div className="relative block">
          <button
            className="flex items-center gap-1 transition-opacity duration-200 hover:opacity-80"
            onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}
          >
            <span className="text-xs font-medium text-ink/60">
              {t(`language.${selectedLanguage}`)}
            </span>
          </button>

          <LanguageDropdown
            isOpen={isLanguageDropdownOpen}
            onClose={() => setIsLanguageDropdownOpen(false)}
            selectedLanguage={selectedLanguage}
            onLanguageChange={setSelectedLanguage}
          />
        </div>
      </div>

      <div className="flex min-h-[calc(100vh-80px)] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="rounded-3xl border border-border bg-surface-card p-8 shadow-lg">
            {/* Icon and visual indicator */}
            <div className="mb-6 flex justify-center">
              <div className="relative">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-status-warning-soft">
                  <FiClock className="h-8 w-8 text-status-warning" />
                </div>
                <div className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-status-error">
                  <FiAlertCircle className="h-4 w-4 text-on-status" />
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="space-y-4 text-center">
              <h1 className="text-2xl font-bold text-ink">
                {t("paymentlink.expired.title")}
              </h1>

              <p className="leading-relaxed text-ink/70">
                {t("paymentlink.expired.description")}
              </p>

              <div className="mt-6 rounded-lg border border-status-warning/25 bg-status-warning-soft p-4">
                <p className="text-sm text-status-warning">
                  <strong>{t("paymentlink.expired.what_now.title")}</strong>
                </p>
                <p className="mt-2 text-sm text-status-warning">
                  {t("paymentlink.expired.what_now.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Expired;
